export const PDF_CONSTANTS = (doc: any) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  return {
    pageWidth,
    pageHeight,
    margins: {
      left: 10,
      right: 10,
      top: 20,
      bottom: 20,
    },
    header: {
      height: 10,
      spaceAfter: 14,
    },
    border: {
      radius: 3,
      width: pageWidth - 20,
      tableBackgroundWidth: pageWidth - 20,
    },
    colors: {
      yellow: [255, 204, 0],
      gray: [85, 85, 85],
      black: [0, 0, 0],
      tableHeaderText: [55, 55, 55],
      grayTotal: [128, 128, 128],
    },
    fonts: {
      primary: "Bahnschrift",
      fallback: "Gotham-Bold",
      sizes: {
        title: 14,
        subtitle: 11,
        normal: 10,
        small: 9,
        tablehead: 8,
        tiny: 6,
        large: 16,
      },
    },
    layout: {
      logo: {
        x: 10,
        y: 5,
        width: 40,
        height: 50,
      },
      title: {
        advertisingServicesY: 10,
        proposalSheetY: 15,
      },
      proposalSheet: {
        x: 140,
        titleY: 40,
        details: {
          proposalIdY: 45,
          proposalDateY: 50,
          proposalByY: 55,
        },
      },
      sections: {
        startY: 67,
        nameOffsetY: 6,
        addressStartOffsetY: 12,
        leftX: 10,
        rightX: 115,
        leftAddressLineHeight: 5,
        rightAddressLineHeight: 4,
        fieldLineHeight: 4.5,
      },
      table: {
        summaryX: 15,
        amountXOffset: 98,
        amountXBase: 25,
        newPageTitleX: 17,
        newPageTitleY: 65,
        sectionTitleOffsetY: 2,
        sectionSpacing: 5,
        minRemainingSpace: 20,
        cellPadding: 1,
        bottomMargin: 10,
      },
      footer: {  // ✅ moved footer here so layout.footer works
        lineWidth: 0.1,
        borderOffset: 5,
        terms: {
          titleOffsetY: 2,
          lineHeight: 3,
          spacingBeforeContact: 3,
        },
        contact: {
          lineHeight: 5,
        },
        totals: {
          lineHeight: 5,
          spaceBeforeTotal: 8,
          totalLineOffset: 6,
          totalLineWidth: 65,
          officeStartOffsetY: 10,
          officeLineHeight: 5,
        },
      },
    },
  };
};
